"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
function CloseButton(props) {
    return (jsx_runtime_1.jsxs("svg", Object.assign({ width: 12, height: 12, fill: "none", "aria-label": "Close button", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [jsx_runtime_1.jsx("title", { children: "Close button" }, void 0), jsx_runtime_1.jsx("path", { d: "M11.7.3c-.4-.4-1-.4-1.4 0L6 4.6 1.7.3C1.3-.1.7-.1.3.3c-.4.4-.4 1 0 1.4L4.6 6 .3 10.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3L6 7.4l4.3 4.3c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L7.4 6l4.3-4.3c.4-.4.4-1 0-1.4z", fill: "#000" }, void 0)] }), void 0));
}
exports.CloseButton = CloseButton;
